import React from "react";

interface ExpandIconProps {
  size?: number;
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

export const ExpandIcon = ({
  size,
  width = 21,
  height = 21,
  color = "#79808A",
  className,
}: ExpandIconProps) => {
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.80732 16.5347C3.80721 16.621 3.82413 16.7065 3.85712 16.7862C3.8901 16.866 3.93849 16.9385 3.99953 16.9995C4.06057 17.0606 4.13305 17.109 4.21282 17.1419C4.29259 17.1749 4.37808 17.1919 4.4644 17.1917L8.17671 17.1917C8.263 17.1917 8.34844 17.1747 8.42816 17.1417C8.50788 17.1087 8.58032 17.0603 8.64134 16.9993C8.70235 16.9383 8.75075 16.8658 8.78377 16.7861C8.81679 16.7064 8.83379 16.621 8.83379 16.5347C8.83379 16.4484 8.81679 16.3629 8.78377 16.2832C8.75075 16.2035 8.70235 16.1311 8.64134 16.07C8.58032 16.009 8.50788 15.9606 8.42816 15.9276C8.34844 15.8946 8.263 15.8776 8.17671 15.8776L6.04863 15.8785L15.8733 6.05388L15.8723 8.18197C15.8723 8.35623 15.9416 8.52336 16.0648 8.64659C16.188 8.76982 16.3551 8.83904 16.5294 8.83904C16.7037 8.83904 16.8708 8.76982 16.994 8.64659C17.1173 8.52336 17.1865 8.35623 17.1865 8.18196L17.1865 4.46965C17.1866 4.38333 17.1697 4.29784 17.1367 4.21807C17.1037 4.1383 17.0553 4.06582 16.9943 4.00479C16.9332 3.94375 16.8608 3.89535 16.781 3.86237C16.7012 3.82939 16.6157 3.81247 16.5294 3.81258L12.8171 3.81257C12.6428 3.81257 12.4757 3.8818 12.3525 4.00503C12.2292 4.12826 12.16 4.29539 12.16 4.46965C12.16 4.64392 12.2292 4.81105 12.3525 4.93428C12.4757 5.05751 12.6428 5.12673 12.8171 5.12673L14.9452 5.1258L5.12055 14.9504L5.12148 12.8224C5.12148 12.6481 5.05225 12.481 4.92903 12.3577C4.8058 12.2345 4.63867 12.1653 4.4644 12.1653C4.29013 12.1653 4.123 12.2345 3.99978 12.3577C3.87655 12.481 3.80732 12.6481 3.80732 12.8224L3.80732 16.5347Z"
        fill={color}
      />
    </svg>
  );
};

export default ExpandIcon;
